const initialState = {
  collaborations: [], // Initialize as an empty array for storing collaboration data
  loading: false,     // Indicates if an API request is in progress
  error: null,        // Stores any error messages
  totalCollaborations: 0, // Total number of collaborations
  showCollaborationForm: false, /// Toggles visibility of the collaboration form
};

const collaborationReducer = (state = initialState, action) => {
  console.log('Reducer Action:', action); // Debug log

  switch (action.type) {
    case "SHOW_COLLABORATION_FORM":
      return { ...state, showCollaborationForm: true };

    case "HIDE_COLLABORATION_FORM":
      return { ...state, showCollaborationForm: false };

    case "FETCH_COLLABORATION_REQUEST":
      console.log('Setting loading state...'); // Debug log
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FETCH_COLLABORATION_SUCCESS":
      console.log('Setting collaborations:', action.payload); // Debug log
      return {
        ...state,
        loading: false,
        collaborations: action.payload,
        totalCollaborations: action.payload.length,
        error: null,
      };

    case "FETCH_COLLABORATION_FAILURE":
      console.log('Setting error state:', action.payload); // Debug log
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ✅ Research area fetch cases
    case "FETCH_COLLABORATIONSRESEARCHAREA_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FETCH_COLLABORATIONSRESEARCHAREA_SUCCESS":
      return {
        ...state,
        loading: false,
        collaborations: action.payload,
        totalCollaborations: action.payload.length,
        error: null,
      };

    case "FETCH_COLLABORATIONSRESEARCHAREA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "ADD_COLLABORATION_REQUEST":
    case "UPDATE_COLLABORATION_REQUEST":
    case "DELETE_COLLABORATION_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "ADD_COLLABORATION_SUCCESS":
      return {
        ...state,
        loading: false,
        collaborations: [...state.collaborations, action.payload],
        totalCollaborations: state.totalCollaborations + 1,
      };

    case "UPDATE_COLLABORATION_SUCCESS":
      return {
        ...state,
        loading: false,
        collaborations: state.collaborations.map((collaboration) =>
          collaboration.projectNo === action.payload.projectNo
            ? { ...collaboration, ...action.payload }
            : collaboration
        ),
      };

    case "DELETE_COLLABORATION_SUCCESS":
      return {
        ...state,
        loading: false,
        collaborations: state.collaborations.filter(
          (collaboration) => collaboration.projectNo !== action.payload
        ),
        totalCollaborations: state.totalCollaborations - 1,
      };

    case "ADD_COLLABORATION_FAILURE":
    case "UPDATE_COLLABORATION_FAILURE":
    case "DELETE_COLLABORATION_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default collaborationReducer;

